module.exports = __webpack_public_path__ + "img/personnel_access_feature_06.a303258d.jpg";